import {
  BODY_FONT,
  DATA_START_ROW,
  HEADER_FONT_11,
  HEADER_FONT_12,
  VALUE_FILL,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  addHiddenTemplateRow,
  addPrinciple2BackLink,
  addSheetTitle,
  addSimpleTableHeader,
  addTableSpacer,
  displayText,
  setupPrinciple2DetailSheet,
  writeDataRow,
  hideRowsThrough,
} from "./principle2DetailHelpers.js";

const SHEET_TITLE =
  "Action taken to mitigate significant social or environmental concerns and/or risks arising from production or disposal of products / services";

export const SHEET_NAME = "Action taken";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 9.1796875,
  E: 45.7265625,
  F: 67.54296875,
  G: 45.7265625,
  H: 9.1796875,
  I: 9.1796875,
  J: 9.1796875,
};

const HEADERS = [
  { col: COL_D, label: "Sr. No.", font: HEADER_FONT_11 },
  { col: COL_E, label: "Name of Product/Service", font: HEADER_FONT_12 },
  { col: COL_F, label: "Description of the risk/concern", font: HEADER_FONT_12 },
  { col: COL_G, label: "Action Taken", font: HEADER_FONT_12 },
];

export function buildActionTakenSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });
  const colEnd = COL_G;

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd,
    lastVisibleCol: 10,
    xSplit: 3,
  });
  addPrinciple2BackLink(ws, colEnd);

  addSheetTitle(ws, colEnd, SHEET_TITLE, {
    borderPatterns: ["tt--", "t---", "t---", "t--t"],
  });
  addSimpleTableHeader(ws, COL_D, colEnd, HEADERS);
  addHiddenTemplateRow(ws, COL_D, colEnd);
  addTableSpacer(ws, COL_D, colEnd);

  const rows = Array.isArray(sectionC?.principle2?.leadershipIndicator?.significantRisksFromLCA)
    ? sectionC.principle2.leadershipIndicator.significantRisksFromLCA
    : [];
  const dataRows = rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(ws, row, COL_D, colEnd, [
      { col: COL_D, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: COL_E, value: displayText(item?.productName), align: "left" },
      {
        col: COL_F,
        value: displayText(item?.descriptionOfRisk),
        align: "left",
        vertical: "top",
        fill: VALUE_FILL,
      },
      {
        col: COL_G,
        value: displayText(item?.actionTaken),
        align: "left",
        vertical: "top",
        fill: VALUE_FILL,
      },
    ]);
    ws.getRow(row).height = 15.5;
  });

  hideRowsThrough(ws, 5);
  return ws;
}
